import { combineReducers } from 'redux'
import authReducer from '../modules/Login/redux/authReducer'
import errorReducer from './errorReducer'
import notificationReducer from '../modules/Notifications/redux/notificationReducer'
import rolesReducer from '../modules/Roles/redux/rolesReducer'
import supportTablesReducer from '../modules/SupportTables/redux/supportTablesReducer'
import userReducer from '../modules/Users/redux/userReducer'
import contactReducer from '../modules/Contacts/redux/ContactReducer'
import redFlagReducer from '../modules/RedFlag/redux/RedFlagReducer'
import divisionReducer from '../modules/Divisions/redux/DivisionReducer'
import helpSuggestionsReducer from '../modules/HelpSuggestions/redux/HelpSuggestionsReducer'
import helpRequestsReducer from '../modules/HelpRequests/redux/HelpRequestsReducer'
import branchReducer from '../modules/Branches/redux/BranchReducer'
import ContactFiltersReducer from '../common/ContactCommonComponents/AdvanceSearch/redux/ContactFiltersReducer'
import SystemReducer from '../modules/System/redux/SystemReducer'

import LastContactReport from '../modules/LastContactReport/redux/LCRReducer'
import DashboardCompass from '../modules/Dashboard/Components/Compass/redux/CompassReducer'
import DashboardDivisions from '../modules/Dashboard/Components/Divisions/redux/DivisionsReducer'
import ProjectionsReducer from '../modules/Projection/redux/projectionsReducer'
import ClickToCallReducer from '../modules/ClickToCall/Redux/clickToCallReducer'
import ContactDetailsDataReducer from '../common/ContactCommonComponents/Details/redux/reducer'
import EsignatureReducer from '../common/E-signature/Redux/eSignatureReducer'
import CalendarReducer from '../modules/Calendar/redux/calendarReducer'
import TaskReducer from '../modules/Task/Redux/taskReducer'
import DashboardSpeedReducer from '../modules/Dashboard/Components/Speed/redux/SpeedReducer'
import StatesReducer from '../modules/States/redux/StateReducer'
import ReferralReducer from '../modules/Contacts/Referral/redux/ReferralReducer'
import ContactActivitiesTimelineReducer from '../common/ContactCommonComponents/ActivitiesTimeline/redux/activitiesTimelineReducer'
import GlobalModalReducer from '../common/GlobalModal/redux/GlobalModalReducer'
import ReferralReportReducer from '../modules/ReferralReport/Redux/referralReportReducer'
import SalesMetricReport from '../modules/SalesMetricReport/Redux/salesMetricReportReducer'
import MerchantReducer from '../modules/Merchants/redux/merchantReducer'
import TSDealersReducer from '../modules/TruckSalesDealers/redux/tsDealersReducer'
import EmailsReducer from '../modules/EmailsMenu/redux/emailsReducer'
import ExpensesReducer from '../modules/Expenses/redux/expenseReducer'
import expirationReportReducer from '../modules/InsuranceExpirationReport/redux/expirationReportReducer'
import ContractLostReducer from '../modules/ContractLostHistory/redux/contractLostReducer'
import ReportsReducer from '../modules/Reports/Redux/reportsReducer'
import DashboardWelcomeAlertsSpeedReducer from '../modules/Dashboard/Components/WelcomeAlertSpeed/redux/WelcomeAlertsSpeedReducer'
import closingRatioReducer from '../modules/Dashboard/Components/ClosingRatio/redux/closingRatioReducer'
import opportunitiesReducer from '../modules/Opportunities/redux/opportunitiesReducer'
import dashboardOpportunityChartReducer from '../modules/Dashboard/Components/OpportunityChart/redux/dashboardOpportunityChartReducer'
import activitySummaryReducer from '../modules/Dashboard/Components/Actions/ActivitySummary/redux/reducer'
import followUpReportReducer from '../modules/Contacts/FollowUpReport/redux/followUpReportReducer'
import creditApplicationsReducer from '../modules/Credit/Applications/redux/applicationReducer'
import ContactAgreementsReducer from '../modules/Credit/Agreements/redux/agreementReducer'
import customerLoadReducer from '../modules/CustomerLogisticsLoads/redux/loadReducer'
import accountsInsightsReducer from '../modules/Dashboard/Components/AccountsInsights/redux/accountsInsightsReducer'
import quotesReducer from '../common/ContactCommonComponents/Details/Quotes/redux/reducers'
import emailReceiversReducer from '../modules/EmailReceivers/redux/emailReceiversReducer'
import inactivityReportReducer from '../modules/InactivityReport/redux/InactivityReportReducer'
import notesSearchReducer from '../modules/Dashboard/Components/NoteSearch/redux/reducer'
import { salesReportReducer } from '../modules/SalesReport/Redux/SalesReportReducer'

const rootReducer = combineReducers({
  errors: errorReducer,
  auth: authReducer,
  notifications: notificationReducer,
  roles: rolesReducer,
  supportTables: supportTablesReducer,
  users: userReducer,
  contacts: contactReducer,
  redFlag: redFlagReducer,
  divisions: divisionReducer,
  helpSuggestions: helpSuggestionsReducer,
  helpRequests: helpRequestsReducer,
  branches: branchReducer,
  contactFilters: ContactFiltersReducer,
  systemData: SystemReducer,
  LCR: LastContactReport,
  DashboardCompass: DashboardCompass,
  DashboardDivisions: DashboardDivisions,
  dashboardSpeed: DashboardSpeedReducer,
  dashboardWelcomeAlertsSpeed: DashboardWelcomeAlertsSpeedReducer,
  dashboardAccountsInsights: accountsInsightsReducer,
  dashboardOpportunityChart: dashboardOpportunityChartReducer,
  dashboardActivitySummary: activitySummaryReducer,
  Projections: ProjectionsReducer,
  ClickToCall: ClickToCallReducer,
  contactDetailsData: ContactDetailsDataReducer,
  Esignature: EsignatureReducer,
  calendar: CalendarReducer,
  Task: TaskReducer,
  states: StatesReducer,
  contactActivitiesTimeline: ContactActivitiesTimelineReducer,
  Referral: ReferralReducer,
  GlobalModal: GlobalModalReducer,
  ReferralReport: ReferralReportReducer,
  SalesMetricReport: SalesMetricReport,
  Merchants: MerchantReducer,
  TSDealers: TSDealersReducer,
  Emails: EmailsReducer,
  Expenses: ExpensesReducer,
  ContractLost: ContractLostReducer,
  Reports: ReportsReducer,
  dashboardClosingRatio: closingRatioReducer,
  opportunities: opportunitiesReducer,
  followUpReport: followUpReportReducer,
  creditApplications: creditApplicationsReducer,
  contactAgreements: ContactAgreementsReducer,
  customerLoads: customerLoadReducer,
  expirationReport: expirationReportReducer,
  quotes: quotesReducer,
  salesReport: salesReportReducer,
  emailReceivers: emailReceiversReducer,
  inactivityReport: inactivityReportReducer,
  notesSearch: notesSearchReducer,
})

export default rootReducer
